import CardsStrategy from "../ListSourceWidget/strategies/CardsStrategy.js";
import GroupByDecorator from "../ListSourceWidget/strategies/GroupByDecorator.js";
import ListSourceWidget from "../ListSourceWidget/ListSourceWidget.js";

/**
 * Return a {@link ListSourceWidget} rendering cards within
 * groups. The groups are provided by source as arrays of
 * items. Before rendering the cards of a group, this renders a group
 * label specified with groupLabelRenderer.
 *
 * @param {ListSource} source - source of truth when it comes to
 *   fetching or manipulating the items
 * @param {function} itemRenderer - Function taking one fetched item
 *   as argument, and returning a Renderable for a card
 * @param {Renderable} [loadingCard] - Optional widget to display as
 *   card when loading
 * @param {Renderable} [trailingWidget] - Optional trailing widget to
 *   append at the end of the list of items
 * @param {string} [cssClass] - Additional CSS class to append to the
 *   root of the widget
 * @param {function(object[]): Renderable} groupLabelRenderer - Takes
 *   the list of items of the corresponding group as argument and
 *   returns what should be rendered as a title for this group
 * @param {function(object, object): integer} [compareFunction] - Takes
 *   two group keys as argument and return a sorting value
 */
export default function makeCardGroupListWidget({
	source,
	itemRenderer,
	loadingCard,
	trailingWidget,
	cssClass,
	groupLabelRenderer,
	compareFunction,
}) {
	const strategy = new GroupByDecorator({
		strategy: new CardsStrategy({
			itemRenderer,
			loadingCard,
			trailingWidget,
			cssClass,
		}),
		groupLabelRenderer,
		compareFunction,
	});

	return new ListSourceWidget({ strategy, source });
}
